import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Flame } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function renderBody(body) {
  return body.split(/\n{2,}/).map((block, i) => {
    const t = block.trim();
    if (!t) return null;
    if (t.startsWith("## ")) {
      return <h2 key={i} className="font-display font-bold text-2xl mt-10 mb-4 text-white">{t.slice(3)}</h2>;
    }
    if (t.startsWith("# ")) {
      return <h2 key={i} className="font-display font-bold text-2xl mt-10 mb-4 text-white">{t.slice(2)}</h2>;
    }
    return <p key={i} className="text-slate-300 leading-relaxed mb-5">{t}</p>;
  });
}

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`)
      .then((r) => {
        setPost(r.data);
        document.title = `${r.data.title} | NOXWAY Journal`;
        let meta = document.querySelector('meta[name="description"]');
        if (meta && r.data.excerpt) meta.setAttribute("content", r.data.excerpt);
        const ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "article-ld";
        ld.text = JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          headline: r.data.title,
          description: r.data.excerpt,
          datePublished: r.data.published_at,
          author: { "@type": "Organization", name: "NOXWAY" },
          publisher: { "@type": "Organization", name: "NOXWAY" },
        });
        document.head.appendChild(ld);
      })
      .catch(() => setMissing(true));
    return () => document.getElementById("article-ld")?.remove();
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#08090d] text-white" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
        <Link to="/blog" className="inline-flex items-center gap-2 font-tech text-[10px] tracking-[0.2em] uppercase text-slate-400 hover:text-[#f97316] transition-colors mb-12" data-testid="post-back">
          <ArrowLeft size={13} /> All guides
        </Link>
        {missing ? (
          <p className="text-slate-500">This guide isn't available.</p>
        ) : !post ? (
          <p className="text-slate-500 text-sm">Loading…</p>
        ) : (
          <motion.article initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} data-testid="blog-article">
            <div className="font-tech text-[10px] tracking-[0.25em] text-[#f97316] uppercase mb-4">
              {(post.published_at || "").slice(0, 10)}
            </div>
            <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-5xl mb-8" data-testid="post-title">{post.title}</h1>
            {renderBody(post.body)}
            <div className="mt-14 card-glow-border rounded-2xl p-7 bg-[#0f1117] flex flex-wrap items-center gap-5">
              <Flame size={22} className="text-[#f97316] shrink-0" />
              <div className="flex-1 min-w-48">
                <div className="font-display font-bold">Protect your property with NOXWAY Formula 100</div>
                <div className="text-sm text-slate-400">CA$1,299 per 5kg bag.</div>
              </div>
              <Link to="/" className="font-display font-bold tracking-[0.12em] text-xs px-6 py-3 rounded-full bg-gradient-to-r from-[#f97316] to-[#ea580c] text-white" data-testid="post-cta">
                SHOP NOXWAY
              </Link>
            </div>
          </motion.article>
        )}
      </div>
    </div>
  );
}
